import React from "react";
import {Container} from "react-bootstrap";
import NutzungLayout from "../../Components/Nutzung/NutzungLayout.jsx";
import useNutzungFilter from "../../Components/Nutzung/useNutzungFilter.js";
import useStatisticsData from "../../Components/Statistics/useStatisticsData.js";
import NutzungUngenutzteFunktionen from "../../Components/Nutzung/NutzungUngenutzteFunktionen.jsx";

/**
 * Eigene Seite für die Funktionen, die im gewählten Zeitraum niemand
 * benutzt hat (Auftrag Teil 4) - die Grundlage zum Ausmisten, deshalb
 * bewusst ALLEIN auf dieser Seite statt als Fußnote unter der
 * Meistgenutzt-Tabelle (siehe Seiten.jsx). Gleicher bestehender Endpunkt
 * /nutzung/daten/funktionen wie zuvor, nur das ungenutzt-Feld ausgewertet.
 */
export default function NutzungUngenutzt() {
    const nutzungFilters = useNutzungFilter();
    const {filters} = nutzungFilters;
    const {data, loading, error} = useStatisticsData("/nutzung/daten/funktionen", filters);

    return (
        <Container fluid className="pt-2 pb-4">
            <NutzungLayout gruppe="Seiten" titel="Nie benutzt" nutzungFilters={nutzungFilters}>
                <p className="text-muted">
                    Funktionen, die im gewählten Zeitraum kein einziger Mitarbeiter aufgerufen hat -
                    die besten Kandidaten, um sie abzuschaffen oder ihren Aufwand zu hinterfragen. Je
                    länger der Zeitraum, desto belastbarer die Aussage.
                </p>
                <NutzungUngenutzteFunktionen ungenutzt={data?.ungenutzt} loading={loading} error={error} />
            </NutzungLayout>
        </Container>
    );
}
